import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError() {
    // עדכון state כך שהרנדור הבא יציג fallback UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // לוג השגיאה
    console.error('Error caught by boundary:', error, errorInfo);
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
    
    // שליחת השגיאה לשרת (אופציונלי)
    this.logErrorToServer(error, errorInfo);
  }

  logErrorToServer(error, errorInfo) {
    // שליחה לשרת או שירות ניטור
    fetch('/api/error', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        error: error.toString(),
        stack: errorInfo.componentStack,
        url: window.location.href,
        userAgent: navigator.userAgent,
        timestamp: new Date().toISOString()
      })
    }).catch(err => {
      console.log('Failed to log error to server:', err);
    });
  }

  render() {
    if (this.state.hasError) {
      // Fallback UI
      return (
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          background: '#ffebee',
          color: '#c62828',
          fontFamily: 'Arial, sans-serif',
          textAlign: 'center',
          padding: '20px'
        }}>
          <div>
            <h2>שגיאה בטעינת האתר</h2>
            <p>אירעה שגיאה בטעינת האתר. אנא רענן את הדף או נסה שוב מאוחר יותר.</p>
            
            {import.meta.env.DEV && this.state.error && (
              <details style={{ marginTop: '20px', textAlign: 'left' }}>
                <summary>פרטי השגיאה (פיתוח)</summary>
                <pre style={{ 
                  background: '#f5f5f5', 
                  padding: '10px', 
                  borderRadius: '5px',
                  fontSize: '12px',
                  overflow: 'auto'
                }}>
                  {this.state.error.toString()}
                  {this.state.errorInfo.componentStack}
                </pre>
              </details>
            )}
            
            <div style={{ marginTop: '20px' }}>
              <button 
                onClick={() => window.location.reload()} 
                style={{
                  padding: '10px 20px',
                  background: '#c62828',
                  color: 'white',
                  border: 'none',
                  borderRadius: '5px',
                  cursor: 'pointer',
                  marginRight: '10px'
                }}
              >
                רענן דף
              </button>
              
              <button 
                onClick={() => this.setState({ hasError: false })} 
                style={{
                  padding: '10px 20px',
                  background: '#2196f3',
                  color: 'white',
                  border: 'none',
                  borderRadius: '5px',
                  cursor: 'pointer'
                }}
              >
                נסה שוב
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary; 